import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Dropdown.module.sass";
import { Link, NavLink, useLocation, useHistory } from "react-router-dom";
import Icon from "../../Icon";

const Dropdown = ({ className, item, visibleSidebar, setValue, onClose, countInHead, colorCounterInHead, collapsed }) => {
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);
  const history = useHistory();
  const { pathname } = useLocation();

  const isGroupActive =
    (item.urlDropdown && pathname.startsWith(item.urlDropdown)) ||
    (item.dropdown && item.dropdown.some((d) => pathname.startsWith(d.url)));

  const isAddActive = item.add && item.addTo && pathname.startsWith(item.addTo);

  useEffect(() => {
    if (isGroupActive) setVisible(true);
  }, [pathname]);

  const handleHeadClick = () => {
    if (collapsed) {
      history.push(item.urlDropdown);
      return;
    }
    setValue(true);
    setVisible(true);
    history.push(item.urlDropdown);
    onClose?.();
  };

  const handleArrowClick = (e) => {
    e.stopPropagation();
    if (!visible) setValue(true);
    setVisible((v) => !v);
  };

  return (
    <div
      className={cn(
        styles.dropdown,
        className,
        { [styles.active]: visible },
        { [styles.wide]: visibleSidebar },
        { [styles.collapsed]: collapsed }
      )}
      onMouseEnter={() => collapsed && setHovered(true)}
      onMouseLeave={() => collapsed && setHovered(false)}
    >
      <div
        className={cn(
          styles.head,
          { [styles.active]: isGroupActive || isAddActive },
          { [styles.wide]: visibleSidebar }
        )}
      >
        <button
          type="button"
          className={styles.headMain}
          onClick={handleHeadClick}
        >
          <span className={styles.iconWrap}>
            <item.icon size="24" />
            {collapsed && countInHead != null && countInHead > 0 && (
              <span
                className={styles.badge}
                style={{ backgroundColor: colorCounterInHead || "#B5E4CA" }}
              >
                {countInHead}
              </span>
            )}
          </span>
          {item.title}
          {!collapsed && !visible && countInHead != null && countInHead > 0 && (
            <div
              className={styles.counter}
              style={{ backgroundColor: colorCounterInHead || "#B5E4CA" }}
            >
              {countInHead}
            </div>
          )}
        </button>
        {item.add && (
          <Link
            className={cn(styles.add, { [styles.active]: isAddActive })}
            to={item.addTo}
            onClick={(e) => { e.stopPropagation(); onClose?.(); }}
          >
            <Icon name="plus" size="10" />
          </Link>
        )}
        <button
          type="button"
          className={styles.headArrow}
          onClick={handleArrowClick}
          aria-label={visible ? "Cerrar grupo" : "Abrir grupo"}
        >
          <Icon name="arrow-down" size="24" />
        </button>
      </div>
      <div className={styles.body}>
        {item.dropdown.map((x, index) => {
          const showCounter = visible && x.counter != null && x.counter > 0;
          return (
            <NavLink
              className={styles.link}
              activeClassName={styles.active}
              to={x.url}
              key={index}
              onClick={onClose}
              exact
            >
              {x.title}
              {showCounter ? (
                <div
                  className={styles.counter}
                  style={{ backgroundColor: x.colorCounter }}
                >
                  {x.counter}
                </div>
              ) : (
                <Icon name="arrow-next" size="24" />
              )}
            </NavLink>
          );
        })}
      </div>
      {collapsed && hovered && (
        <div className={styles.popover}>
          <div className={styles.popoverInner}>
            <NavLink
              className={styles.popoverTitle}
              activeClassName={styles.popoverActive}
              to={item.urlDropdown}
              onClick={() => setHovered(false)}
            >
              {item.title}
            </NavLink>
            {item.dropdown.map((x, index) => (
              <NavLink
                key={index}
                className={styles.popoverLink}
                activeClassName={styles.popoverActive}
                to={x.url}
                onClick={() => setHovered(false)}
                exact
              >
                {x.title}
                {x.counter != null && x.counter > 0 && (
                  <div
                    className={styles.popoverCounter}
                    style={{ backgroundColor: x.colorCounter }}
                  >
                    {x.counter}
                  </div>
                )}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
